export function range(length) {
  return Object.keys(Array.from({ length })).map(i => Number(i))
}
